import axios from 'axios';
import { base_URL } from '../config/config';

const API_BASE_URL = `${base_URL}/`;

export const hotel = async (HotelData) => {
  try {
    const accessToken = localStorage.getItem('accessToken');
    const response = await axios.post(`${API_BASE_URL}api/vendor/addvenue`, HotelData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error registering venue:', error);
    throw error;
  }
};
